import { z } from "zod/v4";

import { ShopifyTemplateTypeType } from "../dtos/shopify";

export const ThemeDtoSchema = z.object({
  id: z.number(),
  name: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  role: z.string(),
  themeStoreId: z.number().nullish(),
  previewable: z.boolean(),
  processing: z.boolean(),
  adminGraphqlApiId: z.string(),
});

export type ThemeType = z.infer<typeof ThemeDtoSchema>;

export const AssetTypeSchema = ["template", "config"] as const;
export type AssetTypeType = (typeof AssetTypeSchema)[number];

export const AssetSchema = z.object({
  key: z.string(),
  publicUrl: z.string().nullish(),
  value: z.string().nullish(),
  themeId: z.number(),
  createdAt: z.string(),
  updatedAt: z.string(),
  contentType: z.string(),
});

export type AssetType = z.infer<typeof AssetSchema>;

export type TemplateAssetType = AssetType & {
  templateType: ShopifyTemplateTypeType;
  isDefault: boolean;
};

export const CartTransformFeaturesSchema = z.object({
  expandOperation: z.boolean(),
  mergeOperation: z.boolean(),
  updateOperation: z.boolean(),
});

export type CartTransformFeaturesType = z.infer<
  typeof CartTransformFeaturesSchema
>;

export const CartTransformSchema = z.object({
  id: z.string(),
  isPricingFunctionId: z.boolean(),
  experiences: z
    .object({
      id: z.uuid(),
      variationIds: z.string().array().nullish(),
    })
    .array()
    .nullish(),
  experiments: z
    .object({
      id: z.uuid(),
      testGroupIds: z.string().array().nullish(),
    })
    .array()
    .nullish(),
  cartTransformMode: z.string().nullish(),
  functionId: z.string(),
});

export type CartTransformType = z.infer<typeof CartTransformSchema>;

export const PageViewDtoSchema = z.object({
  shopId: z.string(),
  title: z.string(),
  eventPage: z.string(),
  views: z.number(),
});

export type PageViewDto = z.infer<typeof PageViewDtoSchema>;
